import React, {Fragment, useEffect, useState} from 'react'
import BulkLocationEditorHours from "./hours/BulkLocationEditorHours";
import BulkLocationEditorSummary from "./BulkLocationEditorSummary";

import apiClient from '../../../services/session/apiClient'
import BulkLocationEditorJobResults from "./_core/BulkLocationEditorJobResults";
import BulkLocationEditorSpecialHours from "./hours/BulkLocationEditorSpecialHours";
import BulkLocationEditorTemporarilyClosed from "./hours/BulkLocationEditorTemporarilyClosed";

import BulkLocationEditorKeywords from "./keywords/BulkLocationEditorKeywords"

import {cloneDeep, merge, uniq} from 'lodash'
import BulkLocationEditorGeneralDetails from "./general/BulkLocationEditorGeneralDetails";
import BulkLocationEditorGeneralLocationTypeStatus from "./general/BulkLocationEditorGeneralLocationTypeStatus";
import BulkLocationEditorGeneralInternalUseOnly from "./general/BulkLocationEditorGeneralInternalUseOnly";
import {UploadGallery} from "../../social/publishing/components/UploadGallery";
import BulkLocationEditorImages from "./images/BulkLocationEditorImages";
import BulkLocationEditorYelp from "./yelp/BulkLocationEditorYelp";
import BulkLocationEditorFacebook from "./facebook/BulkLocationEditorFacebook";
import BulkLocationEditorGoogle from "./google/BulkLocationEditorGoogle";
import BulkLocationEditorBing from "./bing/BulkLocationEditorBing";
import BulkLocationEditorApple from "./Apple/BulkLocationEditorApple";
import * as mobx from "mobx";
import BulkLocationEditorHealthCare from "./healthcare/BulkLocationEditorHealthcare";
import BulkLocationEditorJobResultsCreateMode from "./_core/BulkLocationEditorJobResultsCreateMode";
import AccessStore from "../../../services/locations/AccessStore";
import BulkLocationEditorMenus from "./menus/BulkLocationEditorMenus";
import BulkLocationEditorLocalPages from "./localPages/BulkLocationEditorLocalPages";
import Button from '../../../components/buttons/Button';
import { Confirm } from '../../../components/confirm/Confirm';
import RegionCardHeader from '../../../components/cards/RegionCardHeader';
import { hasRestaurantMenus } from "../../app/site/featureAccessControl";
import locationMigrationStore from "./LocationMigrationStore";
import ScheduleLocationTab from "./_core/ScheduleLocationTab";
import {deleteSchedule} from "../../../services/locations/api"

// This is an empty patch, should not have any effect on the locations if submitted like this
export const emptyLocationPatch = (createMode, accountIdOverride) => ({
  accountId: accountIdOverride || undefined,
  clientLocationId: undefined,
  website: undefined,
  alternateWebsites: [],
  appointmentUrl: undefined,
  businessName: undefined,
  emails: [],
  locationType: null, // Because this is an on/off/null situation, and lodash merge doesn't overwrite values with undefined.. this needs to be null/true/false
  notes: undefined,
  phoneNumber: undefined,
  alternatePhoneNumbers: [],
  primaryCategory: undefined,
  primaryWebsite: undefined,
  additionalCategories: [],
  brandMonitoring: {
    listingMonitoring: [] // "Directory Name Search"
  },
  businessAddress: {
    ...(createMode ? {country: "US"} : {}),
    isServiceAreaLocation: null // Because this is an on/off/null situation, and lodash merge doesn't overwrite values with undefined.. this needs to be null/true/false
  },
  facebookListingManagementSpecs: {
    about: undefined,
    coverPhotoUrl: undefined
  },
  listingManagementSpecs: {
    primaryBingCategory: undefined,
    hideAddress: null, // Because this is an on/off/null situation, and lodash merge doesn't overwrite values with undefined.. this needs to be null/true/false
    hours: [],
    imageUrls: [],
    logoUrl: undefined,
    permanentlyClosed: null, // Because this is an on/off/null situation, and lodash merge doesn't overwrite values with undefined.. this needs to be null/true/false
    specialHours: [],
    temporarilyClosedUntil: undefined,
    yearEstablished: undefined,
    appleCoordinates: undefined,
    bingCategories: [],
    healthCareManagement: {
      nationalProviderIdentifier: undefined,
      specialties: undefined,
      conditionsTreated: undefined,
      acceptingNewPatients: undefined
    },
    appleCategories: [],
    providerTrackingNumbers: {
      "FACEBOOK": undefined,
      "GOOGLEMAP": undefined,
      "BING": undefined
    },
    providerTrackingWebsiteUrls: {
      "FACEBOOK": undefined,
      "GOOGLEMAP": undefined,
      "BING": undefined
    },
  },
  yelpListingManagementSpecs: {
    covidBannerMessage: undefined,
    images: [],
    categories: []
  },
  googleListingManagementSpecs: {
    photos: [],
    doNotMovePin: undefined
  }
});


window.OldLocationInfra = locationMigrationStore;

function BulkLocationEditor({
  createMode,
  selectAccount,
  locationPatch,
  onSelectedLocations,
  startingLocationPatch,
  setLocationPatch,
  combinedLocationServicesMap,
  categoriesStore,
  includeHealthcareVertical,
  accountsStore,
  selectedLocations,
  allLocations,
  yelpCategoriesStore,
  googleAttributesStore,
  bingCategoriesStore,
  appleCategoriesStore,
  selectedLocationsAndGroups,
  locationScheduleMode,
  locationUpdateJobId
}) {


  const [formIsDirty, setFormIsDirty] = useState(false);

  // Forms in create mode are automatically invalid since all required fields need to be filled in
  const [formIsInvalid, setFormIsInvalid] = useState(createMode);

  const [activeTab, setActiveTab] = useState(null);

  const [jobResults, setJobResults] = useState(null);

  const [submitting, setSubmitting] = useState(false);

  const [summaryOpen, setSummaryOpen] = useState(false);

  const [pollJobInterval, setPollJobInterval] = useState(null);

  const [foodMenuSummary, setFoodMenuSummary] = useState(null);

  // If a user is in create mode and they click next before finishing all required* fields, we need to show them all errors
  const [forceGeneralDetailsValidation, setForceGeneralDetailsValidation] = useState(false);

  const setActiveTabByName = (tabName) => {
    setActiveTab(tabs.find(tab => tab.name === tabName))
  };

  const singleLocationMode = selectedLocations.length < 2;
  const tabs = [
      ].concat(locationScheduleMode ? [] : [{
      "name": "General",
      "component": ({locationPatch, combinedLocationServicesMap, _forceGeneralDetailsValidation, includeHealthcareVertical}) => <Fragment>
        <BulkLocationEditorGeneralDetails
          forceGeneralDetailsValidation={_forceGeneralDetailsValidation}
          createMode={createMode}
          selectAccount={selectAccount}
          setFormIsInvalid={setFormIsInvalid}
          singleLocationMode={singleLocationMode}
          combinedLocationServicesMap={combinedLocationServicesMap}
          locationPatch={locationPatch}
          categoriesStore={categoriesStore}
          accountsStore={accountsStore}
          mergeIntoLocationPatch={mergeIntoLocationPatch(locationPatch)}
        />
        <BulkLocationEditorGeneralLocationTypeStatus
          combinedLocationServicesMap={combinedLocationServicesMap}
          locationPatch={locationPatch}
          mergeIntoLocationPatch={mergeIntoLocationPatch(locationPatch)}
        />
        <BulkLocationEditorGeneralInternalUseOnly
          singleLocationMode={singleLocationMode}
          locationPatch={locationPatch}
          accountsStore={accountsStore}
          mergeIntoLocationPatch={mergeIntoLocationPatch(locationPatch)}
        />
        {!!includeHealthcareVertical && <BulkLocationEditorHealthCare
          singleLocationMode={singleLocationMode}
          locationPatch={locationPatch}
          updateHealthCareManagementPatch={updateLocationListingManagementSpecsPatchSection(locationPatch, "healthCareManagement")}
        />}
      </Fragment>
    }])
      .concat(!locationScheduleMode ? [] : [{
      "name": "Schedule", "component": ({locationPatch}) => {
        return <ScheduleLocationTab
        locationPatch={locationPatch}
        mergeIntoLocationPatch={mergeIntoLocationPatch(locationPatch)}
        setFormIsInvalid={setFormIsInvalid}
        combinedLocationServicesMap={combinedLocationServicesMap}
        />
      }
      }])
  .concat([{
      "name": "Hours", "component": ({locationPatch}) => {
        return <Fragment>
          <BulkLocationEditorHours
            setFormIsInvalid={setFormIsInvalid}
            createMode={createMode}
            combinedLocationServicesMap={combinedLocationServicesMap}
            singleLocationMode={singleLocationMode}
            locationPatchHours={locationPatch.listingManagementSpecs.hours}
            updateLocationPatchSection={updateLocationListingManagementSpecsPatchSection(locationPatch, "hours")}
          />
          <BulkLocationEditorTemporarilyClosed
            locationPatchTemporarilyClosed={locationPatch.listingManagementSpecs.temporarilyClosedUntil}
            updateLocationPatchSection={updateLocationListingManagementSpecsPatchSection(locationPatch, "temporarilyClosedUntil")}
          />
          <BulkLocationEditorSpecialHours
            locationPatchSpecialHours={locationPatch.listingManagementSpecs.specialHours}
            updateLocationPatchSection={updateLocationListingManagementSpecsPatchSection(locationPatch, "specialHours")}
          />
        </Fragment>
      }
  }])
  .concat(locationScheduleMode ? [] : [{
      "name": "Keywords", "component": ({locationPatch}) => {
        return <Fragment>
          <BulkLocationEditorKeywords
            overwriteInLocationPatch={overwriteInLocationPatch(locationPatch)}
            locationPatchKeywords={locationPatch.additionalCategories}
          />
        </Fragment>
      }
    }])
  .concat((!combinedLocationServicesMap.listingManagement || locationScheduleMode) ? [] : [{
    "name": "Images", "component": ({locationPatch}) => <BulkLocationEditorImages
      locationPatch={locationPatch}
      updateImageUrls={updateLocationListingManagementSpecsPatchSection(locationPatch, "imageUrls")}
      updateLogoUrl={updateLocationListingManagementSpecsPatchSection(locationPatch, "logoUrl")}/>
  }])
    .concat(!combinedLocationServicesMap.googleListingManagement || locationScheduleMode ? [] :
      [{
        "name": "Google", "component": ({locationPatch}) => <BulkLocationEditorGoogle
          singleLocationMode={selectedLocations.length === 1}
          selectedLocations={selectedLocations}
          locationPatch={locationPatch}
          updateImages={updateGoogleListingManagementSpecsPatchSection(locationPatch, "photos")}
          updatePinFlag={updateGoogleListingManagementSpecsPatchSection(locationPatch, "doNotMovePin")}
          updateAttributes={updateGoogleListingManagementSpecsPatchSection(locationPatch, "attributes")}
          mergeIntoLocationPatch={mergeIntoLocationPatch(locationPatch)}
          categoriesStore={categoriesStore}
          googleAttributesStore={googleAttributesStore }
          mergeGoogleCategoriesIntoLocationPatch={mergeGoogleCategoriesIntoLocationPatch(locationPatch)}
          setFormIsInvalid={setFormIsInvalid}


        />
      }])
    .concat(!combinedLocationServicesMap.yelpListingManagement || locationScheduleMode ? [] :
      [{
        "name": "Yelp", "component": ({locationPatch}) => <BulkLocationEditorYelp
          singleLocationMode={singleLocationMode}
          locationPatch={locationPatch}
          yelpCategoriesStore={yelpCategoriesStore}
          updateCovidBannerMessage={updateYelpListingManagementSpecsPatchSection(locationPatch, "covidBannerMessage")}
          updateCategories={updateYelpListingManagementSpecsPatchSection(locationPatch, "categories")}
          updateImages={updateYelpListingManagementSpecsPatchSection(locationPatch, "images")}/>
      }])
    .concat(!combinedLocationServicesMap.appleListingManagement || locationScheduleMode ? [] :
      [{
        "name": "Apple", "component": ({locationPatch}) => <BulkLocationEditorApple
          singleLocationMode={singleLocationMode}
          locationPatch={locationPatch}
          appleCategoriesStore={appleCategoriesStore}
          updatePrimaryAppleCategory={updateLocationListingManagementSpecsPatchSection(locationPatch, "primaryAppleCategory")}
          updateAppleCategories={updateLocationListingManagementSpecsPatchSection(locationPatch, "appleCategories")}
          mergeIntoLocationPatch={mergeIntoLocationPatch(locationPatch)}
        />
      }])
    .concat(!combinedLocationServicesMap.facebookListingManagement || locationScheduleMode ? [] :
      [{
        "name": "Facebook", "component": ({locationPatch}) => <BulkLocationEditorFacebook
          singleLocationMode={singleLocationMode}
          locationPatch={locationPatch}
          mergeIntoLocationPatch={mergeIntoLocationPatch(locationPatch)}
        />
      }])
    .concat(!combinedLocationServicesMap.bingListingManagement || locationScheduleMode ? [] :
      [{
        "name": "Bing", "component": ({locationPatch}) => <BulkLocationEditorBing
          singleLocationMode={singleLocationMode}
          setFormIsInvalid={setFormIsInvalid}
          locationPatch={locationPatch}
          combinedLocationServicesMap={combinedLocationServicesMap}
          bingCategoriesStore={bingCategoriesStore}
          updatePrimaryBingCategory={updateLocationListingManagementSpecsPatchSection(locationPatch, "primaryBingCategory")}
          updateBingCategories={updateLocationListingManagementSpecsPatchSection(locationPatch, "bingCategories")}
          mergeIntoLocationPatch={mergeIntoLocationPatch(locationPatch)}
        />
      }])
    .concat((!hasRestaurantMenus() || locationScheduleMode) ? [] :
      [{
        "name": "Menus", "component": ({locationPatch}) =>
            <BulkLocationEditorMenus
                setFormIsInvalid={setFormIsInvalid}
                singleLocationMode={singleLocationMode}
                foodMenuId={locationPatch.listingManagementSpecs.foodMenuIds ? locationPatch.listingManagementSpecs.foodMenuIds[0] : null}
                setFoodMenuIdsOnPatch={updateLocationListingManagementSpecsPatchSection(locationPatch, "foodMenuIds")}
                setFoodMenuSummary={setFoodMenuSummary}
            />
      }])
    .concat((!combinedLocationServicesMap.localPages || !singleLocationMode)  && locationScheduleMode ? [] : //Temporarily, don't show local pages tab if multiple locations are selected
      [{
        "name": "Local Pages", "component": ({locationPatch}) => <BulkLocationEditorLocalPages
            singleLocationMode={singleLocationMode}
            accountStore={accountsStore}
            setFormIsInvalid={setFormIsInvalid}
            locationPatch={locationPatch}
            locationIds={selectedLocations}
            selectedLocations={selectedLocations}
            setFormIsDirty={setFormIsDirty}
        />
      }]);
  // {"name": "Dogs", "component": () => <BulkLocationEditorComingSoon />},

  useEffect(() => {
    setActiveTab(tabs[0]);
  }, []);

  // TODO - for some reason I need to pass the location patch down from the rendered component
  // the reference to the state.locationPatch here doesn't ever update for some reason
  const updateLocationListingManagementSpecsPatchSection = (locationPatch, lmSpecsSection) => (sectionDetails) => {
    setFormIsDirty(true);
    const updatedLocationPatch = {
      ...cloneDeep(locationPatch),
      listingManagementSpecs: {
        ...cloneDeep(locationPatch.listingManagementSpecs || {}),
        [lmSpecsSection]: sectionDetails
      }
    };
    setLocationPatch(updatedLocationPatch);
  };

  // TODO - for some reason I need to pass the location patch down from the rendered component
  // the reference to the state.locationPatch here doesn't ever update for some reason
  const updateYelpListingManagementSpecsPatchSection = (locationPatch, yelpLmSpecsSection) => (sectionDetails) => {
    setFormIsDirty(true);
    const updatedLocationPatch = {
      ...cloneDeep(locationPatch),
      yelpListingManagementSpecs: {
        ...cloneDeep(locationPatch.yelpListingManagementSpecs || {}),
        [yelpLmSpecsSection]: sectionDetails
      }
    };

    setLocationPatch(updatedLocationPatch);
  };

  const updateFacebookListingManagementSpecsPatchSection = (locationPatch, facebookLmSpecsSection) => (sectionDetails) => {
    setFormIsDirty(true);
    const updatedLocationPatch = {
      ...cloneDeep(locationPatch),
      facebookListingManagementSpecs: {
        ...cloneDeep(locationPatch.facebookListingManagementSpecs || {}),
        [facebookLmSpecsSection]: sectionDetails
      }
    };

    setLocationPatch(updatedLocationPatch);
  };


  const updateGoogleListingManagementSpecsPatchSection = (locationPatch, googleLmSpecsSection) => (sectionDetails) => {
    setFormIsDirty(true);
    const updatedLocationPatch = {
      ...cloneDeep(locationPatch),
      googleListingManagementSpecs: {
        ...cloneDeep(locationPatch.googleListingManagementSpecs || {}),
        [googleLmSpecsSection]: sectionDetails
      }
    };
    setLocationPatch(updatedLocationPatch);
  };

  const mergeGoogleCategoriesIntoLocationPatch = (locationPatch) => (mergeIn) => {
    setFormIsDirty(true);
    const updatedLocationPatch = {
      ...cloneDeep(locationPatch),
      googleListingManagementSpecs: {
        ...cloneDeep(locationPatch.googleListingManagementSpecs || {}),
        googleCategories: mergeIn
      }
    };
    setLocationPatch(updatedLocationPatch);
  };

  const overwriteInLocationPatch = (locationPatch) => (mergeIn) => {
    setFormIsDirty(true);
    const lpCopy = {
      ...locationPatch,
      ...mergeIn
    }
    setLocationPatch(lpCopy)
  };

  const mergeIntoLocationPatch = (locationPatch) => (mergeIn) => {
    setFormIsDirty(true);
    const merged = merge(cloneDeep(locationPatch), cloneDeep(mergeIn));
    if (Array.isArray(mergeIn.alternateWebsites)) {
      // Special cases for alternate websites thanks to odd data structure
      merged.alternateWebsites = mergeIn.alternateWebsites
    }
    if (Array.isArray(mergeIn.alternatePhoneNumbers)) {
      // Special cases for alternate websites thanks to odd data structure
      merged.alternatePhoneNumbers = mergeIn.alternatePhoneNumbers
    }
    if (singleLocationMode && Array.isArray(mergeIn.emails)) {
      merged.emails = mergeIn.emails;
    }
    setLocationPatch(merged)
  };


  const pollingInterval = 2000

  // Poll a data for completion stats every 2 seconds
  const pollJob = (jobId) => {
    const pollJobInterval = window.setInterval(() => {
      apiClient.get('/locations/bulk/job/' + jobId)
        .then(response => {
          if (response.status === 200) {
            setJobResults(cloneDeep(response.data));

            if (response.data.status === "Complete") {
              // Kill interval after job completed
              AccessStore.invalidate();
              clearInterval(pollJobInterval)
            }
          } else {
            clearInterval(pollJobInterval)
          }
        })
    }, pollingInterval);

    setPollJobInterval(pollJobInterval);
  };

  const pollLocationUpdateJob = (jobId) => {
    const pollingInterval = 2000
    const pollJobInterval = window.setInterval(() => {
      setJobResultsViaSummaryEndpoint(jobId, pollJobInterval)
    }, pollingInterval);
    // To reduce lag in showing the status of the updates, resolve the summary right away.
    setJobResultsViaSummaryEndpoint(jobId, pollJobInterval)

    setPollJobInterval(pollJobInterval);
  };

  const setJobResultsViaSummaryEndpoint = (jobId, pollJobInterval) => {
    apiClient.get('/internal/jobs/Location/summary/' + jobId)
      .then(response => {
        console.log(response)
        if (response.status === 200) {
          const transformed = transformLocationUpdateSummaryToResultSummary(response.data)
          setJobResults(cloneDeep(transformed));

          if (transformed.status !== "Executing") {
            // Kill interval after the job has reached an end state
            AccessStore.invalidate();
            clearInterval(pollJobInterval)
          }
        } else {
          setJobResults({
            _id: {$oid: "Unknown"},
            locationIds: [],
            failedLocationIdsAndErrors: [],
            processedLocationIds: [],
            status: "Failure"
          })
          clearInterval(pollJobInterval)
        }
      }).catch( error => {
        setJobResults({
          _id: {$oid: "Unknown"},
          locationIds: [],
          failedLocationIdsAndErrors: [],
          processedLocationIds: [],
          status: "Failure"
        })
        clearInterval(pollJobInterval)
    })
  }

  const transformLocationUpdateSummaryToResultSummary = (summary) => {

    if (!!summary) {
      function getReducedStatus(status) {
        switch (status) {
          case "CompletedSuccessfully":
            return "Complete";
          case "Verifying":
          case "Scheduled":
          case "Queuing":
          case "Processing":
          case "WaitingApproval":
          case "Approved":
            return "Executing";
          default:
            return "Failure";
        }
      }
      const status = getReducedStatus(summary.status)

      const locationIds = summary?.updates.filter(x => {
        const status = getReducedStatus(x.status)
        return (status === "Executing")
      }).map( update => update.locationId)
      const failedLocationIdsAndErrors = summary?.updates.filter(x => {
        const status = getReducedStatus(x.status)
        return (status === "Failure")
      }).map( update => {
        return {
          locationId: update.locationId,
          error: !!update?.status ? update?.status : "An unknown error occurred."
        }
      })
      const processedLocationIds = summary?.updates.filter(x => {
        const status = getReducedStatus(x.status)
        return (status === "Complete")
      }).map( update => update.locationId)

      return {
        _id: {$oid: summary.jobId},
        locationIds: !!locationIds && locationIds.length ? locationIds : [],
        failedLocationIdsAndErrors: !!failedLocationIdsAndErrors && failedLocationIdsAndErrors.length ? failedLocationIdsAndErrors : [],
        processedLocationIds: !!processedLocationIds && processedLocationIds.length ? processedLocationIds : [],
        status: status
      }
    } else {
      return {
        _id: {$oid: "Unknown"},
        locationIds: [],
        failedLocationIdsAndErrors: [],
        processedLocationIds: [],
        status: "Failure"
      }
    }
  }

  const submitLocationPatch = () => {
    setSubmitting(true);

    // The bing category selector doesn't handle selecting by entire object well, so I selected by key and mapped to the objects
    const allBingCategories = mobx.toJS(bingCategoriesStore.categories);
    const allAppleCategories = mobx.toJS(appleCategoriesStore.categories)
    const selectedBingCategories = locationPatch.listingManagementSpecs.bingCategories.map(categoryText => {
      const category = allBingCategories.find(bingCategory => bingCategory.text.toLowerCase() === categoryText.toLowerCase())
      return {
        BPCategoryId: category.categoryId,
        CategoryName: category.text
      }
    });

    const selectedAppleCategories = locationPatch.listingManagementSpecs.appleCategories.map(categoryId => {
      const category = allAppleCategories.find(appleCategory => appleCategory.categoryId === categoryId)
      return {
        categoryId: category.categoryId,
        categoryName: category.text
      }
    });
    const maybePrimaryBingCategory = !!locationPatch.listingManagementSpecs.primaryBingCategory && allBingCategories.find(bingCategory => bingCategory.text.toLowerCase() === locationPatch.listingManagementSpecs.primaryBingCategory.toLowerCase());
    const maybePrimaryAppleCategory = !!locationPatch.listingManagementSpecs.primaryAppleCategory && allAppleCategories.find(appleCategory => appleCategory.categoryId === locationPatch.listingManagementSpecs.primaryAppleCategory);

    const bingCategories = singleLocationMode ? selectedBingCategories : ((!!selectedBingCategories && selectedBingCategories.length > 0) ? selectedBingCategories : null);
    if (!!createMode) {
      // Create mode is synchronous
      // We know the result of the job immediately
      setJobResults("Executing")
    }

    // Be able to support the old and new infra to be able to quickly revert should we need.
    const headers = locationMigrationStore.useOld ? {
      useOldJobInfrastructure: "useOldJobInfrastructure"
    } : {
      // Temporarily use old infra to ensure customers can still update everything correctly.
      useOldJobInfrastructure: "useOldJobInfrastructure"
    }


    return apiClient.patch('/locations/bulk', {
      locationPatch: {
        ...locationPatch,
        listingManagementSpecs: {
          ...locationPatch.listingManagementSpecs,
          primaryBingCategory: !!maybePrimaryBingCategory ? {
            BPCategoryId: maybePrimaryBingCategory.categoryId,
            CategoryName: maybePrimaryBingCategory.text
          } : null,
          bingCategories,
          primaryAppleCategory: !!maybePrimaryAppleCategory ? {
            categoryId: maybePrimaryAppleCategory.categoryId,
            categoryName: maybePrimaryAppleCategory.text
          } : null,
          appleCategories: (!!selectedAppleCategories && selectedAppleCategories.length > 0) ? selectedAppleCategories : null,
          foodMenuIds: locationPatch.listingManagementSpecs.foodMenuIds,
          healthCareManagement: JSON.stringify(locationPatch.healthCareManagement) === "{}" ? undefined : locationPatch.healthCareManagement
        }
      },
      createMode: !!createMode,
      overwriteValues: (selectedLocations.length === 1),
      locationIds: selectedLocations
    }, {
      headers
    })
      .then(response => {
        if (response.status === 200) {
          if (!!createMode) {
            // Create mode is synchronous
            // We know the result of the job immediately
            setJobResults("Success")
            AccessStore.invalidate();
            // Give the user some time to see that their location was created successfully and redirect them to the manage locations page
            setTimeout(() => {
              window.location.href = "/#/admin/v2/locations";
            }, 3000)
          } else {
            const maybeBulkId = response.data?._id && response.data?._id["$oid"]
            if (!!maybeBulkId) {
              // Patch mode is asynchronous, we need to poll for updates on the status of the jobsw
              setJobResults(cloneDeep(response.data));
              pollJob(maybeBulkId)
            } else {
              pollLocationUpdateJob(response.data.locationUpdateJobId)
            }
          }
        } else if (response.status === 401) {
          // TODO - inaccessible locations (should be impossible via ui since we only display accessible locations)
          if (!!createMode) {
            // Create mode.
            setJobResults("Failure")
            // TODO: Future improvement--If the job failed due to a validation error, surface failures to the user in a meaningful way.
          }
        }
        setSubmitting(false);
      }).catch( (error) => {
        const response = error.response
        if (response.status === 400) {
          console.log(JSON.stringify(response.data.error))

          let results = {
            status: "Failure"
          };
          if (!!response.data && !!response.data.error) {
            const errorBody = response.data.error
            results = {
              ...results,
              error: errorBody?.message,
              failedLocationIdsAndErrors: errorBody?.errors.map((error) => {
                return {
                  locationId: error.patch.locationId,
                  error: !!error?.errors && error?.errors.length ? error?.errors.map(x => `${x.field}: ${x.message}`).join(",") : "An unknown error occurred."
                }
              })
            }
          }
          setJobResults(results)
        } else {
          console.log(JSON.stringify(response))
          // TODO: Future improvement--Add helpful information for users
          if (!!createMode) setJobResults("Failure")
          else setJobResults({status: "Failure"})
        }
      })
  };

  const reset = () => {
    setLocationPatch(cloneDeep(emptyLocationPatch(createMode)));
    setActiveTab(null);
    setFormIsDirty(false);
    setJobResults(null);
    setSummaryOpen(false);
    onSelectedLocations(selectedLocationsAndGroups, undefined, true); // Refresh location editor
    !!pollJobInterval && clearInterval(pollJobInterval);
    setPollJobInterval(null);

    setTimeout(() => setActiveTab(tabs[0]), 0);
  };

  const cancel = () => {
    reset();
    location.assign("/#/admin/v2/locations");
  }

  const [confirmationVisible, toggleConfirmation] = useState(false);

  return !summaryOpen ? <div className="card">
    <RegionCardHeader classNames="d-flex flex-row align-items-center" titleClasses="card-title-sm" title={
      !createMode && (selectedLocations.length > 0
        ?
        <span>Editing {selectedLocations.length} Location{selectedLocations.length > 1 && "s"}</span>
        :
        <span>Select locations to edit</span>)
    }>
      <div className="ml-auto">
        {
          (locationScheduleMode && locationUpdateJobId) ? <Button outline onClick={() => {
            deleteSchedule(locationUpdateJobId).then(() => {
              // TODO: COFE-350 add redirect to calendar
              window.location.href = "/#/admin/v2/locations"
            })
          }}>
            Delete Schedule
          </Button> : undefined
        }
        <Button outline className="control-spacer-left" onClick={() => toggleConfirmation(true)}>
          Cancel
        </Button>
        <Confirm
          visible={confirmationVisible}
          onContinue={cancel}
          toggle={() => toggleConfirmation(false)}
          header={`Continue?`}
          message="All of your unsaved changes will be lost"
        />
        <Button outline className="control-spacer-left" disabled={!formIsDirty} onClick={reset}>
          Clear Changes
        </Button>
        <Button
          className={`control-spacer-left ${(formIsInvalid ? " disabled" : "")}`}
          disabled={!formIsDirty}
          onClick={() => {
            if (formIsInvalid) {
              // Show all errors on General tab if form is invalid
              setForceGeneralDetailsValidation(true)
            } else {
              setSummaryOpen(true)
            }
        }}>
          Review Changes
        </Button>
      </div>
    </RegionCardHeader>
    <div className="card-body card-footerless">
      <div className="card-padding-top card-spacer-bottom d-flex align-items-center justify-content-between w-100">
        <ul className="nav nav-pills">
          {tabs.map((tab, index) => {
            return (
              <li 
                data-analyticsclick={`${tab.name}`} 
                onClick={() => !formIsInvalid && setActiveTab(tab)}
                className={"nav-item nav-link" + (!!activeTab && activeTab.name === tab.name ? " active" : "") + (formIsInvalid && !!activeTab && activeTab.name !== tab.name ? " cursor-not-allowed" : "")}
                key={index}
              >
                {tab.name}
              </li>
            )
          })}
        </ul>
      </div>
      <div>
        {!submitting && !!activeTab && activeTab.component({
          _forceGeneralDetailsValidation: forceGeneralDetailsValidation,
          locationPatch,
          jobResults,
          combinedLocationServicesMap,
          includeHealthcareVertical
        })}
      </div>
    </div>
    </div>
    : <div className="card table-card">
    <div className="card-header d-flex align-items-center justify-content-between">
      <h2 className="card-title-lg">Listing Details</h2>
      {jobResults === null && <div className="float-right">
        <button className="btn btn-outline-secondary" disabled={!formIsDirty} onClick={reset}>Cancel Changes</button>
        <button className="btn btn-secondary" style={{"marginLeft": "10px"}} disabled={submitting || formIsInvalid}
                onClick={submitLocationPatch}>Save and Submit Changes
        </button>
      </div>}
      {jobResults !== null && <div className="float-right">
      <button className="btn btn-secondary" disabled={!formIsDirty} onClick={reset}>Make More Edits</button>
    </div>}
    </div>
    <div className="card-body card-footerless">
      <BulkLocationEditorSummary
        setFormIsInvalid={setFormIsInvalid}
        accountsStore={accountsStore}
        categoriesStore={categoriesStore}
        singleLocationMode={singleLocationMode}
        combinedLocationServicesMap={combinedLocationServicesMap}
        locationPatch={locationPatch}
        startingLocationPatch={startingLocationPatch}
        yelpCategoriesStore={yelpCategoriesStore}
        bingCategoriesStore={bingCategoriesStore}
        googleAttributesStore={googleAttributesStore}
        appleCategoriesStore={appleCategoriesStore}
        setActiveTab={(tabName) => {
          setActiveTabByName(tabName);
          setSummaryOpen(false)
        }} jobResults={jobResults}
        hideEditButtons={jobResults !== null}
        foodMenuSummary={foodMenuSummary}
        createMode={createMode}
      />
      <div className="card-padding pb-0">
        {jobResults !== null && !createMode && <BulkLocationEditorJobResults jobResults={cloneDeep(jobResults)} locations={allLocations}/>}
        {jobResults !== null && !!createMode && <BulkLocationEditorJobResultsCreateMode status={jobResults?.status ? jobResults.status : jobResults} jobResults={jobResults} />}
      </div>
    </div>
  </div>
}

export default BulkLocationEditor
